<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <sc-dialog-title>{{'Fahrzeug abrufen' | translate:['tmc-yard.widgets.sac-client.moving-order-dialog.title',
    translationService.language]}}</sc-dialog-title>
  <sc-separator-line></sc-separator-line>
  <sc-flex-fitting-content [vertical]="true">
    <sc-padding [fitHeight]="true">

      <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">

        <sc-flex-fitting-content [vertical]="true">
          <sc-scroll-pane>
            <app-moving-order-vehicle-selection
              (selectedVehicle)="vehicleSelected($event)"></app-moving-order-vehicle-selection>
          </sc-scroll-pane>
        </sc-flex-fitting-content>

        <sc-content-spacer [vertical]="true"></sc-content-spacer>

        <div>
          <sc-padding>
            <mat-slide-toggle [(ngModel)]="withTransport">
              {{'merge with planned transport' |
              translate:['tmc-yard.widgets.sac-client.moving-order-dialog.merge-with-planned-transport',
              translationService.language]}}
            </mat-slide-toggle>
          </sc-padding>
        </div>

        <sc-flex-fitting-content [vertical]="true" *ngIf="withTransport">
          <sc-scroll-pane>
            <app-planned-transport-selection [targetStationId]="targetStationId" [onlyPlanned]="true"
              [findOnlyNextPlannedRoutingPosition]="true"
              (selectedTransport)="transportSelected($event)"></app-planned-transport-selection>
          </sc-scroll-pane>
        </sc-flex-fitting-content>

      </sc-flex>

    </sc-padding>

  </sc-flex-fitting-content>
  <sc-separator-line></sc-separator-line>
  <sc-padding>
    <sc-flex>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button mat-dialog-close>{{'Cancel' |
        translate:['tmc-yard.widgets.sac-client.moving-order-dialog.action.cancel',
        translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button [disabled]="!createMovementOrderEnabled" (click)="createMovementOrder()">
        {{'Abruf erstellen' | translate:['tmc-yard.widgets.sac-client.moving-order-dialog.action.createMovingOrder',
        translationService.language]}}
      </button>
    </sc-flex>
  </sc-padding>
</sc-flex>
